import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuggestionNotifyFloatComponent } from './suggestion-notify-float.component';
import { SuggestionNotifyModule } from '../suggestion-notify/suggestion-notify.module';

@NgModule({
  declarations: [SuggestionNotifyFloatComponent],
  imports: [
    CommonModule,
    SuggestionNotifyModule
  ],
  exports: [SuggestionNotifyFloatComponent]
})
export class SuggestionNotifyFloatModule {}
